/**
 * Rewrite storefront search to field-scoped keyword queries.
 * Shopify semantic search otherwise expands designer names to unrelated brands.
 */
(function () {
  var SEARCH_FIELDS = ["title", "vendor", "product_type", "tag", "body"];
  var FIELD_QUERY_RE = /(?:^|\s|\()(title|vendor|product_type|tag|body):/i;

  function isFieldQuery(query) {
    return FIELD_QUERY_RE.test(query || "");
  }

  function sanitizeToken(token) {
    return String(token || "")
      .replace(/[:"*()\\]/g, "")
      .trim();
  }

  function buildKeywordQuery(raw) {
    if (!raw) return raw;
    var trimmed = String(raw).trim().replace(/^"+|"+$/g, "");
    if (!trimmed) return raw;
    if (isFieldQuery(trimmed)) return trimmed;

    var words = trimmed
      .split(/\s+/)
      .map(sanitizeToken)
      .filter(function (word) {
        return word && /[a-z0-9]/i.test(word);
      });

    if (!words.length) return trimmed;

    return words
      .map(function (word) {
        return (
          "(" +
          SEARCH_FIELDS.map(function (field) {
            return field + ":" + word;
          }).join(" OR ") +
          ")"
        );
      })
      .join(" AND ");
  }

  function displayTerms(query) {
    if (!query) return "";
    if (!isFieldQuery(query)) {
      return String(query)
        .replace(/^"+|"+$/g, "")
        .replace(/\*/g, "")
        .trim();
    }

    var words = [];
    var fieldMatch;
    var titleRe = /title:([^\s)]+)/gi;
    while ((fieldMatch = titleRe.exec(query))) {
      var word = sanitizeToken(fieldMatch[1]);
      if (word && words.indexOf(word) === -1) words.push(word);
    }
    return words.join(" ") || String(query).trim();
  }

  function locationParts(href) {
    var parsed = new URL(href, window.location.origin);
    return parsed.pathname + parsed.search + parsed.hash;
  }

  function rewriteSearchUrl(href) {
    try {
      var parsed = new URL(href, window.location.origin);
      var current = parsed.pathname + parsed.search + parsed.hash;
      if (parsed.pathname.indexOf("/search") === -1) return current;
      var query = parsed.searchParams.get("q");
      if (!query || isFieldQuery(query)) return current;
      parsed.searchParams.set("q", buildKeywordQuery(query));
      if (!parsed.searchParams.get("type")) {
        parsed.searchParams.set("type", "product");
      }
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (error) {
      return locationParts(href);
    }
  }

  function currentSearchHref() {
    return locationParts(window.location.href);
  }

  function redirectBareSearchQuery() {
    if (window.location.pathname.indexOf("/search") === -1) return;
    var current = currentSearchHref();
    var rewritten = rewriteSearchUrl(window.location.href);
    if (rewritten !== current) {
      window.location.replace(rewritten);
    }
  }

  function handleFormSubmit(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;

    var action = (form.getAttribute("action") || "").toLowerCase();
    if (action && action.indexOf("search") === -1) return;

    var keywordQuery = buildKeywordQuery(input.value);
    if (!keywordQuery || keywordQuery === input.value) return;

    event.preventDefault();
    var params = new URLSearchParams(new FormData(form));
    params.set("q", keywordQuery);
    if (!params.get("type")) params.set("type", "product");

    var destination = form.getAttribute("action") || "/search";
    var separator = destination.indexOf("?") === -1 ? "?" : "&";
    window.location.assign(destination + separator + params.toString());
  }

  function restoreVisibleSearchInputs() {
    var params = new URLSearchParams(window.location.search);
    var query = params.get("q");
    if (!query || !isFieldQuery(query)) return;
    var visible = displayTerms(query);
    document.querySelectorAll('input[name="q"]').forEach(function (input) {
      if (isFieldQuery(input.value)) input.value = visible;
    });
  }

  window.theme = window.theme || {};
  theme.buildKeywordSearchQuery = buildKeywordQuery;
  theme.searchDisplayTerms = displayTerms;
  theme.rewriteSearchUrl = rewriteSearchUrl;

  redirectBareSearchQuery();
  document.addEventListener("submit", handleFormSubmit, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", restoreVisibleSearchInputs);
  } else {
    restoreVisibleSearchInputs();
  }
})();
